<template>
  <div>
    <div style="margin:0 auto;text-align:center;">
      <h1>溫馨提示</h1>
      <div style="font-size:20px;margin-top:40px;">
        為了提供更好的在線購物服務，網店已搬遷至https://www.megawine.net
      </div>
      <div class="app-title" style="font-size:20px;margin-top:20px;">        
        <a
          href="https://www.megawine.net"
          style="text"
          >立即進入</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.app-title {
  img {
    margin: 0 5px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 40px;
}
</style>
